import { useMount } from 'react-use';
import { useTranslation } from 'react-i18next';

import { useHistory, useLocation } from '@app/router';
import { useToast } from '@stockx/ui';

const useHandlePostVerifyEmail = () => {
  const history = useHistory();
  const { t } = useTranslation();

  const { search } = useLocation();
  const toast = useToast();

  useMount(() => {
    if (!search) {
      return;
    }

    const params = new URLSearchParams(search);
    const emailVerified = params.get('emailVerified');

    if (!emailVerified) {
      return;
    }

    if (emailVerified === 'true') {
      toast({
        message: t('verify_email_success'),
        isCloseable: true,
      });
    } else if (emailVerified === 'false') {
      toast({
        message: t('verify_email_error_support'),
        isCloseable: true,
      });
    }

    history.replace('/');
  });
};

export default useHandlePostVerifyEmail;
